import React from 'react';
import styled from 'styled-components';
import { NavLayout } from '../enum/EnumRepository';
import { useNavLayout } from '../hooks/useNavLayout';

interface ArchivePageFrameProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
}

const ArchivePageFrame: React.FC<ArchivePageFrameProps> = ({ children, ...rest }) => {
  const navLayout = useNavLayout();

  return (
    <Frame $navLayout={navLayout} {...rest}>
      {children}
    </Frame>
  );
};

const Frame = styled.main<{ $navLayout: NavLayout }>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: ${({ $navLayout }) =>
    $navLayout === NavLayout.FIXED
      ? 'calc(8vh) clamp(20px, 2vw, 30px) calc(8vh) clamp(12px, 1.2vw, 20px)'
      : 'calc(8vh) calc(6vw)'};
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export default ArchivePageFrame;
